/**
 * Stories written
 */
/* eslint-disable local-rules/require-storybook-documentation */
import { FunctionComponent } from 'react';
import { Banner, Anchor } from '@zillow/constellation-10';

/**
 * A component that renders a warning informing the user that they are using a non-stable environment.
 */
export const DevEnvironmentWarning: FunctionComponent = () => (
    <Banner tone="warning">
        <b>You're currently using the development instance of Home Loans Dashboard.</b>
        <br />
        The Pathfinders team does not guarantee stability or functionality on this instance. Please consider using the{' '}
        <Anchor href="https://www.qa.zillow.net/homeloans/mortgage/dashboard/login">staging</Anchor> instance.
    </Banner>
);
